import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useBreakpoints } from "../lib/breakpoints";
import { HeaderContainer, MainHeader, Spacer } from "../styles/CommonElements";
import ContactPage from "../pages/home/ContactPage";
import Hidden from "../components/Hidden";
import SEO from "../components/SEO";
import { APP_NAME } from "../helpers/constants";
import { trackEvent } from "../helpers/mixpanel";

export default function Contact() {
  const location = useLocation();
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  const handleContactClick = () => {
    trackEvent("Contact CTA Click", {
      from_page: window.location.pathname,
      device_type:
        window.innerWidth < 600
          ? "mobile"
          : window.innerWidth < 1200
          ? "tablet"
          : "desktop",
    });
  };

  return (
    <Container>
      <SEO
        title={`Contact Us | ${APP_NAME} - Stop Carrying Your Rentals in Your Head`}
        description={`Have questions about tracking decisions and follow-ups? Contact ${APP_NAME} to learn how we help self-managing landlords centralize what happens next - especially when automation isn't enough.`}
        keywords={`contact ${APP_NAME}, landlord decisions follow-ups, property management support, landlord software help, landlord cognitive load, when automation isn't enough`}
        imageAlt={`Contact ${APP_NAME} for property management support and questions`}
        category="Portfolio & Door Management"
        url="https://landlordops.com/contact"
        canonical="https://landlordops.com/contact"
        tags={[
          "contact LandlordOps",
          "landlord decisions follow-ups",
          "property management support",
          "landlord cognitive load",
        ]}
      />
      <ContactPage />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;
